<script>
import General from '@/services/General';
import { required} from "vuelidate/lib/validators";
import validationMessages from '@/components/validations'


export default {
  components:{
    validationMessages
  },
  props: ['securityGroupData'],
  data() {
    return {
      csrf_token: localStorage.getItem('csrf_token'),
      submitted: false,
      showModal: false,
      tryingToEdit: false,
      showLoader:false,
      modalTitle:'',
      cidrIp: '',
      description:'',
      updatingData: false
    };
  },

  validations: {
    cidrIp: {
      required,
      valid: function(value) {
        return this.validIp(value)
      },
    },
  },
  methods: {

    async addIngressRule(){

      this.tryingToEdit = true;
      this.submitted = true;
      this.$v.$touch();

      if (this.$v.$invalid) {
        this.tryingToEdit = false;
        return;
      } else {
        try {

          let tenant = process.env.VUE_APP_TENANT
          let description = '('+tenant+')' + ' ' + this.description

          await General.addTenantSecurityGroupRule({
            CidrIp: this.cidrIp,
            Description: description,
            csrf_token: this.csrf_token
          }).then((response) => {
            this.successmsg(response.data.data);
            this.closeModal()
          }).catch(error => {
            this.error = error.response.data.error ? error.response.data.error : "";
            this.failedmsg(this.error);
          }).finally(() => {
            this.refreshData();
            this.submitted = false
          });
        } catch (error) {
          this.error = error.response.data.error ? error.response.data.error : "";
          this.failedmsg(this.error);
        }
      }

      this.tryingToEdit = false;
    },

    refreshData() {
      this.$emit('onRefresh')
    },

    closeModal() {
      this.showModal = false
    },

    resetData(){
      this.cidrIp = ''
      this.description = ''
    }

  }
};
</script>

<template>
  <b-modal @hide="resetData" v-model="showModal" id="addSecurityGroupRules" title="Add New Security Group Rule" title-class="font-18" size="xl" centered>
    <form @submit.prevent="addIngressRule">
      <div class="row">

        <div class="col-sm-6 col-md-4">
          <div class="form-group">
            <label for="CidrIp">Public IP - (Optional CIDR Format) :</label>
            <input type="text" id="CidrIp"
                   placeholder="xxx.xxx.xxx.xxx"
                   class="form-control"
                   v-model="cidrIp"
                   :class="{
                      'is-invalid': submitted && $v.cidrIp.$error,
                    }"
            />
            <validationMessages v-if="submitted" :fieldName="'CIDR IP'" :validationName="$v.cidrIp"></validationMessages>
          </div>
        </div>
        <div class="col-sm-6 col-md-6">
          <div class="form-group">
            <label for="description">Description :</label>
            <input type="text" id="description"
                   class="form-control"
                   v-model="description"
            />
          </div>
        </div>

      </div>
    </form>

    <template v-slot:modal-footer>
      <b-button variant="light" @click="closeModal">Close</b-button>
      <b-button variant="primary" @click="addIngressRule" :disabled="tryingToEdit" >
        <b-spinner v-show="tryingToEdit" small></b-spinner>
        Add New Rule
      </b-button>
    </template>
  </b-modal>
</template>